import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Image, Button, Form } from 'react-bootstrap';
import { HiMail } from 'react-icons/hi';
import { AiOutlineInstagram, AiOutlineFacebook } from 'react-icons/ai';
import { FaGlobe, FaPhoneAlt, FaMapMarkerAlt, FaClock, FaBookOpen, FaCalendarAlt, FaStar } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { getLibraryDetail, getActivitiesByLibraryId, postLibraryRating, postLibraryComment } from 'api/company';
import Rating from 'react-rating';
//styles
import './library-detail.scss';
import LibraryMap from 'components/libraryMap';

const LibraryDetail = () => {
  const { t } = useTranslation(['backoffice']);
  const { id } = useParams();
  const [library, setLibrary] = useState(null);
  const [activities, setActivities] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLibraryData = async () => {
      try {
        const response = await getLibraryDetail(id);
        const libraryData = response.data;
        setLibrary(libraryData);
        const activityParams = {
          page: 1,
          page_size: 10,
          search: '',
          type_schedule: '',
          actives: true,
          ordered_by: 'start',
        };
        const activityResponse = await getActivitiesByLibraryId(id);
        setActivities(activityResponse.data);
      } catch (error) {
        setLibrary(null);
        setActivities(null);
      }
    };
    fetchLibraryData();
  }, [id]);

  const handleRatingChange = async (rate) => {
    setRating(rate);
    const payload = {
      library: 1,
      rating: rate,
    };
    try {
      const response = await postLibraryRating(payload);
    } catch (error) {}
  };

  const handleCommentSubmit = async () => {
    if (comment.trim().length === 0) {
      setError(t('camporequerido'));
      return;
    }
    const payload = {
      library: 1,
      comment: comment,
    };
    try {
      const response = await postLibraryComment(payload);
      setComment('');
      setError('');
    } catch (error) {}
  };

  return (
    <div>
      <div className="p-4 pb-0 pb-md-4 container-detail-library">
        <div className="container-img-library">
          <div className="w-100">
            {library?.logo && (
              <Image
                src={library.logo}
                alt={library.name || 'Library Logo'}
                fluid
                className="border rounded mx-auto w-100"
              />
            )}
          </div>
        </div>
        <Col xs={12} md={7} className="w-65">
          <h1 className="m-3 titleItem">{library?.name}</h1>
          <div className="mt-5 mx-3">
            {library?.descripcion_pub && <p className="mt-5">{library.descripcion_pub}</p>}
            {library?.direccion && (
              <p className="mt-5">
                <FaMapMarkerAlt className="me-2 link-icon" />
                {library.direccion}
                {library.city ? `, ${library.city}` : ''}
                {library.pais?.nombre ? `, ${library.pais.nombre}` : ''}.
              </p>
            )}
          </div>
          <div className="mx-3">
            {library?.email && (
              <div className="mb-3">
                <HiMail className="me-2 link-icon" size={23} />
                <a href={`mailto:${library.email}`} className="text-decoration-none text-dark">
                  {library.email}
                </a>
              </div>
            )}
            {library?.web_url && (
              <p>
                <FaGlobe className="me-2 link-icon" />
                <a
                  href={library.web_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none link-icon link-hover-icon"
                >
                  {library.web_url}
                </a>
              </p>
            )}
            {library?.telefono && (
              <p>
                <FaPhoneAlt className="me-2 link-icon" />
                {library.telefono}
              </p>
            )}
            {library?.business_hours && (
              <p>
                <FaClock className="me-2 link-icon" />
                {library.business_hours && library.business_hours !== 'null' ? library.business_hours : ''}
              </p>
            )}
            {library?.services?.length > 0 && (
              <p>
                <FaBookOpen className="me-2 link-icon" />
                {library.services.map((service, index) => (
                  <span key={index}>
                    {service.name}
                    {index < library.services.length - 1 && ', '}
                  </span>
                ))}
              </p>
            )}
            {(library?.redes_sociales?.twitter ||
              library?.redes_sociales?.facebook ||
              library?.redes_sociales?.instagram) && (
              <div className="mb-3">
                {library?.redes_sociales?.twitter && (
                  <a
                    href={library.redes_sociales.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="me-3 link-icon link-hover-icon"
                  >
                    <FaXTwitter size={24} />
                  </a>
                )}
                {library?.redes_sociales?.facebook && (
                  <a
                    href={library.redes_sociales.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="me-3 link-icon link-hover-icon"
                  >
                    <AiOutlineFacebook size={24} />
                  </a>
                )}
                {library?.redes_sociales?.instagram && (
                  <a
                    href={library.redes_sociales.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="me-3 link-icon link-hover-icon"
                  >
                    <AiOutlineInstagram size={24} />
                  </a>
                )}
              </div>
            )}
          </div>
        </Col>
      </div>
      <Row className="justify-content-center p-4 pt-0 pt-md-4">
        <Col xs={12} md={12} className="d-flex">
          <Card className="shadow-sm flex-grow-1 card-detail mb-4 mb-md-0">
            <h2 className="mb-4">{t('upcomingActivities')}</h2>
            {activities && activities.length > 0 ? (
              <Row>
                {activities.map((activity) => (
                  <Col key={activity.id} sm={12} md={12} lg={12} className="mb-3">
                    <Card className="card-activities">
                      <Row>
                        <Col xs={12} md={3} lg={3} className="d-flex justify-content-center mb-3 mb-md-0">
                          <Image
                            src={activity.image}
                            alt={activity.title || 'Activity Logo'}
                            className="border rounded half-width-image"
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="d-flex justify-content-start align-items-center">
                          <div className="text-justify">
                            <h5 className="mb-3 mt-0">{activity.title}</h5>
                            <p className="mb-3 mb-md-0">{activity.type_schedule?.name}</p>
                          </div>
                        </Col>
                        <Col xs={12} md={5} lg={5} className="d-flex justify-content-center align-items-center">
                          <div className="text-justify">
                            {activity.start_date && activity.end_date && (
                              <p>
                                <FaCalendarAlt className="me-2 text-primary" />
                                {new Date(activity.start_date).toLocaleDateString()} -{' '}
                                {new Date(activity.end_date).toLocaleDateString()}
                              </p>
                            )}
                            {activity.place && (
                              <p className="mb-0">
                                <FaMapMarkerAlt className="me-2 text-primary" />
                                {activity.place}
                              </p>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <p>{t('thereNoActivities')}</p>
            )}
          </Card>
        </Col>
        {/* <Col xs={12} md={6} className="d-flex">
          <Card className="shadow-sm flex-grow-1 card-detail mb-4 mb-md-0">
            <h2 className="mb-4">{t('tellExperience')}</h2>
            <Row>
              <Col xs={12} md={12} lg={12} className="text-center">
                <Rating
                  initialRating={rating}
                  onChange={handleRatingChange}
                  emptySymbol={<FaStar className="empty-star" />}
                  fullSymbol={<FaStar className="full-star" />}
                />
              </Col>
              <Col xs={12} md={12} lg={12} className="text-center">
                <Form>
                  <Form.Group controlId="userComment" className="mt-4 px-4">
                    <Form.Control
                      as="textarea"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder={t('writeYourCommentHere')}
                      required
                      rows={6}
                    />
                  </Form.Group>
                  {error && <p className="text-danger px-4 mt-1 text-start">{error}</p>}
                  <Button
                    variant="primary"
                    className="mt-3 button-secondary"
                    onClick={handleCommentSubmit}
                  >
                    {t('enviar')}
                  </Button>
                </Form>
              </Col>
            </Row>
          </Card>
        </Col> */}
      </Row>
      <Row className="justify-content-center">
        <Col xs={12} md={12} className="p-0">
          {library?.latitude && library?.longitude && (
            <LibraryMap userLocation={{ lat: parseFloat(library.latitude), lng: parseFloat(library.longitude) }} />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LibraryDetail;
